import script from "./BillList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BillList.vue?vue&type=script&lang=ts&setup=true"

import "./BillList.vue?vue&type=style&index=0&id=46910302&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46910302"]])

export default __exports__